import { Component, OnInit } from '@angular/core';
import gsap from 'gsap';

@Component({
  selector: 'app-anim-dwdm',
  templateUrl: './anim-dwdm.component.html',
  styleUrls: ['./anim-dwdm.component.scss']
})
export class AnimDwdmComponent implements OnInit {
  tlDwdm = gsap.timeline({ repeat: -1 });

  pathTowerLeft = 188;
  pathTowerCenter = 47;
  pathTowerRight = 198;
  pathLeftBottom = 250;
  pathCenterBottom = 72;
  pathRightBottom = 274;

  constructor() { }

  ngOnInit(): void {
    this.animate();
  }

  ngOnDestroy(): void{
    this.tlDwdm.kill();
  }

  animate() {
    // let tl = gsap.timeline({ repeat: -1 });

    this.tlDwdm.add(this.animateCenterLine().eventCallback('onComplete', () => {
      let paths = document.querySelectorAll('.dashpath.center-box');
      paths.forEach(path => {
        path.classList.add('offline');
      })
    }));

    this.tlDwdm.to('.alas-bc-icon', {
      fill:'url(#dwdm_paint24_linear_red)',
      duration:0.5,
    }).to('.bc-icon', {
      filter:'url(#dwdm_filter2_d_red)',
      duration:0.5,
    }).to('.center-mark', {
      opacity:1,
      duration:1.5
    }).addLabel('startOffline');
    
    this.tlDwdm.add(this.animateOffline().eventCallback('onComplete', () => {
      let paths = document.querySelectorAll('.dashpath.center-box');
      paths.forEach(path => {
        path.classList.remove('offline');
      })
    }));
  }

  resetPathOffset(path) {
    gsap.set(path, {
      strokeDashoffset:
        path == '.path-tower-boxleft'       ? -this.pathTowerLeft :
        path == '.path-tower-boxcenter'     ? -this.pathTowerCenter :
        path == '.path-tower-boxright'      ? -this.pathTowerRight :
        path == '.path-boxleft-boxbottom'   ? -this.pathLeftBottom :
        path == '.path-boxcenter-boxbottom' ? -this.pathCenterBottom :
        path == '.path-boxright-boxbottom'  ? -this.pathRightBottom :
        'unset'
    });
  }

  animateCenterLine() {
    let tl = gsap.timeline({ repeat: 2 });

    tl.to('.path-tower-boxcenter', {
      strokeDashoffset: this.pathTowerCenter,
      duration: 0.5,
      onComplete: this.resetPathOffset,
      onCompleteParams: ['.path-tower-boxcenter']
    }).add(this.animateBar('center'), "<");
    
    tl.to('.path-boxcenter-boxbottom', {
      strokeDashoffset: this.pathCenterBottom,
      duration: 0.5,
      onComplete: this.resetPathOffset,
      onCompleteParams: ['.path-boxcenter-boxbottom']
    }, "<+=0.5").add(this.animateBar('bottom'), "<");

    return tl;
  }

  animateBar(name) {
    const box = document.querySelector('.box-' + name);
    const barLeft = '.box-' + name + ' .bar-left.bar-';
    const barRight = '.box-' + name + ' .bar-right.bar-';
    const gray = '#999';
    const darkblue = '#2474BA';
    const lightblue = 'url(#dwdm_paint15_linear)';
    const barSpeed = 0.2;
    
    let tl = gsap.timeline();
    if (!box.classList.contains('animate-bar')) {
      box.classList.add('animate-bar');

      tl.addLabel('bar1', barSpeed * 0);
      tl.addLabel('bar2', barSpeed * 1);
      tl.addLabel('bar3', barSpeed * 2);

      tl.set(barLeft + 1, { fill: darkblue }, 'bar1');
      tl.set(barRight + 1, { fill: darkblue }, 'bar1');

      tl.set(barLeft + 2, { fill: darkblue }, 'bar2');
      tl.set(barRight + 2, { fill: lightblue }, 'bar2');

      tl.set(barLeft + 3, { fill: lightblue }, 'bar3');
      tl.set(barRight + 3, { fill: darkblue }, 'bar3');
      tl.addLabel('endFill', ">+1");

      // revert
      tl.set(barLeft + 3, { fill: gray }, 'endFill');
      tl.set(barRight + 3, { fill: gray }, 'endFill');

      tl.set(barLeft + 2, { fill: gray }, 'endFill+=' + (barSpeed * 1));
      tl.set(barRight + 2, { fill: gray }, 'endFill+='  + (barSpeed * 1));

      tl.set(barLeft + 1, { fill: gray }, 'endFill+='  + (barSpeed * 2));
      tl.set(barRight + 1, { fill: gray }, 'endFill+='  + (barSpeed * 2));

      tl.eventCallback('onComplete', ()=>{
        box.classList.remove('animate-bar');
      });
    }
    return tl;
  }

  animateOffline() {
    let tl = gsap.timeline({ repeat: 1 });

    tl.addLabel('startWave1');
    tl.to('.path-tower-boxleft', {
      strokeDashoffset: this.pathTowerLeft,
      duration: 1,
      onComplete: this.resetPathOffset,
      onCompleteParams: ['.path-tower-boxleft']
    }).addLabel('endWave1')
    .add(this.animateBar('left'), 'startWave1');

    tl.to('.path-boxleft-boxbottom', {
      strokeDashoffset: this.pathLeftBottom,
      duration: 1,
      onComplete: this.resetPathOffset,
      onCompleteParams: ['.path-boxleft-boxbottom']
    }, 'endWave1').addLabel('endWave2')
    .add(this.animateBar('bottom'), 'endWave1');

    tl.to('.path-tower-boxright', {
      strokeDashoffset: this.pathTowerRight,
      duration: 1,
      onComplete: this.resetPathOffset,
      onCompleteParams: ['.path-tower-boxright']
    }, "endWave2").addLabel('endWave3')
    .add(this.animateBar('right'), 'endWave2');

    tl.to('.path-boxright-boxbottom', {
      strokeDashoffset: this.pathRightBottom,
      duration: 1,
      onComplete: this.resetPathOffset,
      onCompleteParams: ['.path-boxright-boxbottom']
    }, "endWave3")
    .add(this.animateBar('bottom'), 'endWave3');

    return tl;
  }

  animateRedBlue(){
    let tl = gsap.timeline({ repeat: 4 });

    tl.to('.center-mark', {
      y:0,
      duration:0.5,
    }).to('.alas-bc-icon', {
      fill:'url(#dwdm_paint24_linear_blue)',
      duration:0.001,
    }).to('.bc-icon', {
      filter:'url(#dwdm_filter2_d_blue)',
      duration:0.001,
    }).to('.icon-mark', {
      fill:'url(#dwdm_paint45_linear_blue)',
      duration:0.001,
    })
    
    .to('.center-mark', {
      y:-15,
      duration:0.5,
    }).to('.alas-bc-icon', {
      fill:'url(#dwdm_paint24_linear_red)',
      duration:0.001,
    }).to('.bc-icon', {
      filter:'url(#dwdm_filter2_d_red)',
      duration:0.001,
    }).to('.icon-mark', {
      fill:'url(#dwdm_paint45_linear_red)',
      duration:0.001,
    })
    
    return tl;
  }
}
